module.exports = __webpack_public_path__ + "img/photo9.109b480b.jpg";